export default __webpack_public_path__ + "static/media/assessment-icon.be45dde7.svg";